import React, {Component} from 'react';
import '../css/MemberSite.css';
import '../css/AdviserPortal.css';
import {Link, Route} from 'react-router-dom';
import { withTranslation } from 'react-i18next';

import BalanceByAccount from './BalanceByAccount';
import TransactionHistory from './TransactionHistory';
import FutureStrategy from './FutureStrategy';
import PersonalDetails from './PersonalDetails';
import ContributionDetails from './ContributionDetails';
import Documents from './Documents';


class MemberSite extends Component{
    constructor(props){
        super(props);
        this.handleMenuColor = this.handleMenuColor.bind(this);
        this.state = {
            loading: false,
            usrMemberSetId: null,
        }
    }
    
    style={
        
        color: "#4f4848"
    }

    static getDerivedStateFromProps(props, state) {
        const usrMemberSetId = props.match.params.usrMemberSetId;
        return {
            usrMemberSetId: usrMemberSetId,
        }
    }
    
    componentDidMount(){
        this.props.startLoadingMemberDetails(this.state.usrMemberSetId);
        this.props.startLoadingMemberContribution(this.state.usrMemberSetId);
    }
    
    componentDidUpdate(prevProps, prevState){
        if(document.getElementById(this.props.match.params.menu))
            document.getElementById(this.props.match.params.menu).style.color = "#81B037";
    }

    handleMenuColor(e){
       e.target.style.color = "#81B037";
       if(e.target.id === "balanceByAccount"){
           document.getElementById("transactionHistory").style.color = "#4f4848";
           document.getElementById("futureStrategy").style.color = "#4f4848";
           document.getElementById("personalDetails").style.color = "#4f4848"; 
           document.getElementById("contributionDetails").style.color = "#4f4848"; 
           document.getElementById("documents").style.color = "#4f4848"; 
       }
       if(e.target.id === "transactionHistory"){
           document.getElementById("balanceByAccount").style.color = "#4f4848";
           document.getElementById("futureStrategy").style.color = "#4f4848";
           document.getElementById("personalDetails").style.color = "#4f4848"; 
           document.getElementById("contributionDetails").style.color = "#4f4848"; 
           document.getElementById("documents").style.color = "#4f4848"; 
       }
       if(e.target.id === "futureStrategy"){
           document.getElementById("balanceByAccount").style.color ="#4f4848";
           document.getElementById("transactionHistory").style.color = "#4f4848"; 
           document.getElementById("personalDetails").style.color = "#4f4848"; 
           document.getElementById("contributionDetails").style.color = "#4f4848"; 
           document.getElementById("documents").style.color = "#4f4848"; 
       }
       if(e.target.id === "personalDetails"){
           document.getElementById("balanceByAccount").style.color ="#4f4848";
           document.getElementById("transactionHistory").style.color = "#4f4848";
           document.getElementById("futureStrategy").style.color = "#4f4848";
           document.getElementById("contributionDetails").style.color = "#4f4848"; 
           document.getElementById("documents").style.color = "#4f4848"; 
       }
       if(e.target.id === "contributionDetails"){
           document.getElementById("balanceByAccount").style.color ="#4f4848";
           document.getElementById("transactionHistory").style.color = "#4f4848"; 
           document.getElementById("personalDetails").style.color = "#4f4848"; 
           document.getElementById("futureStrategy").style.color = "#4f4848";
           document.getElementById("documents").style.color = "#4f4848"; 
       }
       if(e.target.id === "documents"){
           document.getElementById("balanceByAccount").style.color ="#4f4848";
           document.getElementById("transactionHistory").style.color = "#4f4848"; 
           document.getElementById("personalDetails").style.color = "#4f4848"; 
           document.getElementById("contributionDetails").style.color = "#4f4848"; 
           document.getElementById("futureStrategy").style.color = "#4f4848";
       }
    }

    render(){
        const {t} = this.props
        if(this.props.member && this.props.member.usrMemberSetId === Number(this.state.usrMemberSetId)) {
            return(
                <div id='member-site'>
                    <div id="demo" style={{ marginBottom: "20px" }}>
                        <table style={{ margin: "auto" }}>
                            <thead>
                                <th>
                                    <button className="memberSite" onClick={(e) => this.handleMenuColor(e)}  defaultChecked="true">
                                        <Link className="link" id="personalDetails" style={this.style}
                                            to={`/adv/memberSite/${this.state.usrMemberSetId}/personalDetails/summary`}>
                                            {t('memberSite:personalDetails')}</Link>
                                    </button>
                                </th>
                                <th>
                                    <button className="memberSite" onClick={(e) => this.handleMenuColor(e)}>
                                        <Link className="link" id="contributionDetails" style={this.style}
                                            to={`/adv/memberSite/${this.state.usrMemberSetId}/contributionDetails/summary`}>
                                            {t('memberSite:contributionDetails')}</Link>
                                    </button>
                                </th>
                                <th>
                                    <button className="memberSite link-memberSite"
                                        onClick={(e) => { this.handleMenuColor(e) }}>
                                        <Link className="link" id="balanceByAccount" style={this.style}
                                            to={`/adv/memberSite/${this.state.usrMemberSetId}/balanceByAccount/accounts`}>
                                            {t('memberSite:balanceByAccount')}
                                        </Link>
                                    </button>
                                </th>
                                <th>
                                    <button className="memberSite" onClick={(e) => this.handleMenuColor(e)}>
                                        <Link className="link" id="transactionHistory" style={this.style}
                                            to={`/adv/memberSite/${this.state.usrMemberSetId}/transactionHistory/summary`}>
                                            {t('memberSite:transactionHistory')}</Link>
                                    </button>
                                </th>
                                <th>
                                    <button className="memberSite" onClick={(e) => this.handleMenuColor(e)}>
                                        <Link className="link" id="futureStrategy" style={this.style}
                                            to={`/adv/memberSite/${this.state.usrMemberSetId}/futureStrategy/investments`}>
                                            {t('memberSite:futureStrategy')}</Link>
    
                                    </button>
                                </th>
                                <th>
                                    <button className="memberSite" onClick={(e) => this.handleMenuColor(e)}>
                                        <Link className="link" id="documents" style={this.style}
                                            to={`/adv/memberSite/${this.state.usrMemberSetId}/documents/all`}>
                                            {t('memberSite:documents')}</Link>
                                    </button>
                                </th>
                            </thead>
                        </table>
                    </div>
                    
                    <Route path="/adv/memberSite/:usrMemberSetId/personalDetails/summary" render={(params) =>
                        <PersonalDetails {...this.props}/>}></Route>
                    <Route path="/adv/memberSite/:usrMemberSetId/contributionDetails/summary" render={(params) =>
                        <ContributionDetails {...this.props} {...params}/>}></Route>
                    <Route path="/adv/memberSite/:usrMemberSetId/balanceByAccount/:tab" render={(params) =>
                        <BalanceByAccount {...this.props} {...params} />}></Route>
                    <Route path="/adv/memberSite/:usrMemberSetId/transactionHistory/:tab" render={(params) =>
                        <TransactionHistory {...this.props} {...params} />} />
                    <Route path="/adv/memberSite/:usrMemberSetId/futureStrategy/investments" render={(params) =>
                        <FutureStrategy {...this.props} {...params} />} />
                    <Route path="/adv/memberSite/:usrMemberSetId/documents/all" render={(params) =>                        
                        <Documents {...this.props} {...params} />}></Route>
                </div>
            )
        }
        else {
            return         <div></div>

        }
            
        
    }
}

export default withTranslation()(MemberSite);